var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"allmap"}},[_c('div',{attrs:{"id":"l-map"}}),_c('div',{attrs:{"id":"r-result"}})])
}]

export { render, staticRenderFns }